import { DateTime } from "luxon";
import type { MbscEventUpdateEvent } from "@mobiscroll/react";
import type { BookingScheduleInterface } from "../../../features/Booking-Form/typings/booking.types";
import { bookingHasSeriesId } from "../functions/booking-has-series-id.function";
import type { SeriesCalendarPendingTimeEdit } from "./hooks/use-series-calendar-time-edit.hook";

type BuildArgs = {
  schedule: BookingScheduleInterface | undefined;
  event: MbscEventUpdateEvent;
  timezone: string;
};

/**
 * When a calendar drag/resize targets a series booking, builds the pending
 * series time-edit payload; otherwise returns null (caller uses single update).
 */
export function buildSeriesCalendarTimeEditFromEventUpdate({
  schedule,
  event,
  timezone
}: BuildArgs): SeriesCalendarPendingTimeEdit | null {
  if (!schedule || !bookingHasSeriesId(schedule.seriesId)) {
    return null;
  }

  const newStartTime =
    DateTime.fromJSDate(new Date(event.event.start as string)).toISO() || DateTime.now().toISO();
  const newEndTime =
    DateTime.fromJSDate(new Date(event.event.end as string)).toISO() || DateTime.now().toISO();

  return {
    schedule,
    bookingId: Number(event.event.id),
    newStartTime,
    newEndTime,
    timezone,
    event,
    selectedDateIso: schedule.start ?? schedule.startDate
  };
}
